import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { isSpinning } from '../../app/spinner';
import {hideLocation, selectFilteredLocations} from '../locations';
import Address from '../components/Address';
import AddressbookInfo from '../components/AddressbookInfo';
import Bar from '../../../ui/Bar';
import Button from '../../../ui/Button';
import Badge from '../../../ui/Badge';
import Icon from '../../../ui/Icon';
import ImmutablePropTypes from 'react-immutable-proptypes';
import IsSpinning from '../../app/containers/IsSpinning';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Search from './Search';
import styles from './css/List.scss';
import buttonStyles from '../../../ui/css/Button.scss';
import {getAddressbooks, selectAddressbooks} from "../addressbooks";
import classNames from "classnames";

@injectIntl
export class AddressbookList extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        intl: intlShape,
        loading: PropTypes.bool,
        locations: ImmutablePropTypes.map.isRequired,
    }

    constructor (props) {
        super(props)
        this.state = {
            selectedAddressbookId: 0
        }
    }

    static defaultProps = {
        loading: true,
    }

    componentDidMount() {
        this.props.dispatch(getAddressbooks({}, { spinner: 'addressbook' }));
    }

    componentWillMount() {
        window.scrollTo(0, 0);
    }

    handleHide(id) {
        this.props.dispatch(hideLocation(id));
    }

    render() {
        const { loading, addressbooks } = this.props;
        const { selectedAddressbookId } = this.state;

        const locations = this.props.locations.sortBy(loc => loc.get('createdAt')).reverse();
        const filteredLocations = this.filterLocationsByAddressbook(locations, selectedAddressbookId);

        return (
            <Page.Body>
                <Page.Section depth={0}>
                    <h1>
                        <FormattedMessage id='frontend.addressbook.headline.addresses' />
                    </h1>
                    <Bar>
                        <Bar.Section float='left'>
                            <Search />
                        </Bar.Section>
                        <Bar.Section float='right'>
                            <Button link to='/addressbook/address/new' emphasis='primary'>
                                <FormattedMessage id='addressbook.address.new' />
                            </Button>
                        </Bar.Section>
                    </Bar>
                </Page.Section>
                {this.renderAddressbookFilter(addressbooks)}
                <Page.Section>
                    {filteredLocations.map(location => (
                        <div className={styles.address} key={location.get('id')}>
                            <Address location={location} />
                            <Bar>
                                <Bar.Section float='left'>
                                    <AddressbookInfo location={location} />
                                </Bar.Section>
                                <Bar.Section float='right'>
                                    <a className={classNames(buttonStyles.button, buttonStyles.small)}
                                       onClick={() => {this.handleHide(location.get('id'))}}>
                                        <i className='fa fa-fw fa-eye-slash'></i>
                                        <FormattedMessage id='frontend.addressbook.button.hide_location' />
                                    </a>
                                    <Button to={`/addressbook/address/edit/${location.get('id')}`} link size='small'>
                                        <i className='fa fa-fw fa-pencil'></i>
                                        <FormattedMessage id='frontend.addressbook.button.edit_address' />
                                    </Button>
                                </Bar.Section>
                            </Bar>
                        </div>
                    )).toArray()}
                    {!loading && filteredLocations.isEmpty() && (
                        <Page.Content>
                            <FormattedMessage id='frontend.addressbook.text.no_addresses' />
                        </Page.Content>
                    )}
                    <IsSpinning id='addressbook'>
                        <div className={styles.loadingMessage}>
                            <Icon name='refresh' spin fixedWidth />{' '}
                            <FormattedMessage id='common.helper.please_wait' />
                        </div>
                    </IsSpinning>
                </Page.Section>
            </Page.Body>
        );
    }

    filterLocationsByAddressbook(locations, addressbookId) {
        if (addressbookId === 0) {
            return locations
        }
        return locations.filter(location => location.get('addressbookId') === addressbookId);
    }

    handleClick(addressbookId) {
        this.setState({selectedAddressbookId: addressbookId})
    }

    renderAddressbookFilter(addressbooks) {
        const { locations } = this.props;

        const locationCount = locations.count();

        return (
            <Page.Section  depth={0}>
                <div className={styles.filter}>
                    {addressbooks.size > 0 ? <Button size='small'
                        emphasis={this.state.selectedAddressbookId === 0 ? 'primary' : 'default'}
                        key={0}
                        onClick={() => this.handleClick(0)}>
                        <FormattedMessage id='frontend.addressbook.text.all_addresses'/>
                        <Badge emphasis='light'>{locationCount}</Badge>
                    </Button> : null}
                    {addressbooks ?
                        Array.from(addressbooks.values()).map((addressbook) => (
                            <Button size='small'
                                emphasis={this.state.selectedAddressbookId === addressbook.get('id') ? 'primary' : 'default'}
                                key={addressbook.get('id')}
                                onClick={() => this.handleClick(addressbook.get('id'))}>
                                { console.log(addressbook.get('id'), addressbook) }
                                {addressbook.get('type') === 'addressbook.personal' ? (
                                    <FormattedMessage id='frontend.form_selector_addressbook.select.option.personal_addressbook' />
                                ) : addressbook.get('name')}
                                <Badge emphasis='light'>{this.filterLocationsByAddressbook(locations, addressbook.get('id')).count()}</Badge>
                            </Button>
                        )) : null}
                </div>
            </Page.Section>
        )
    }
}

export default connect(state => ({
    loading: isSpinning(state, 'addressbook'),
    locations: selectFilteredLocations(state),
    addressbooks: selectAddressbooks(state),
}))(AddressbookList);
